import React from 'react';
import { ShimmerTable } from 'react-shimmer-effects';

function ItemShimmer() {
    return (
        <div className='mt-3'>
            <div className="w-full table-auto relative ">
                <ShimmerTable row={10} col={8} />
            </div>
        </div>
    );
}

export default ItemShimmer;